export class Vehicle {
  _id?: string;
  id: number;
  name: string;
  model: string;
  year?: string;
  businessName?: string;
  brand: string;
  plate: string;
  entryDate: any;
  tankId: number;
  companyId?: string;
  deleted: boolean;
  razon_social?: string;
  driver?: string;
}
